import { forwardRef } from "react";

import styled from "styled-components/macro";

import { motion } from "framer-motion";

export const MoreButton = forwardRef(
  ({ onClick, disabled, forceHover, style, color, children }, ref) => {
    return (
      <MoreButtonWrapper
        onClick={!disabled ? onClick : undefined}
        className={forceHover && "forceHover"}
        style={style}
        ref={ref}
        color={color}
      >
        <MoreButtonInside whileTap={{ scale: 0.9 }}>
          {children}
        </MoreButtonInside>
      </MoreButtonWrapper>
    );
  }
);

const MoreButtonWrapper = styled.div`
  color: #59706a;
  padding: 8px 14px;
  font-size: 14px;
  cursor: pointer;
  border-radius: 8px;
  border: 1px solid rgba(152, 164, 165, 0);
  position: relative;
  z-index: 100;
  transition: 0.2s;
  flex-shrink: 0;

  &:hover,
  &.forceHover {
    border: 1px solid #98a4a5;
    background: #fff;
    color: ${(props) => props.color ?? "#278dc1"};
  }
  &:active {
    border: 1px solid ${(props) => props.color ?? "#278dc1"};
  }
`;
const MoreButtonInside = styled(motion.div)`
  display: flex;
`;

export const MoreButtonText = styled.div`
  font-weight: 400;
  margin-left: 8px;
`;
